<!--
 * @LastEditTime: 2024-12-16 15:06:51
 * @Description: 扩展属性列表
-->
<template>
  <div>
    <el-table
      :data="valueList"
      v-loading="tableLoading"
      :highlight-current-row="true"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      height="328"
      row-key="id"
      stripe
      border
    >
      <el-table-column type="index" width="65" :label="$t('seqNo')" prop="seqNo"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item.name"
        :prop="`${item.tableName}.${item.columnName}`"
        show-overflow-tooltip
        min-width="150"
      >
        <template slot-scope="scope">
          {{
            flag === 1
              ? scope.row[`${item.tableName}.${item.columnName}`]
              : scope.row[`${item.val}`]
          }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="flag === 1"
      class="mt-20px"
      background
      @size-change="searchList()"
      @current-change="getList()"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="page.pageSize"
      layout="->, total, sizes, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
import documentManagementService from '@/services/documentManagement'

export default {
  name: 'extendTable',
  props: {
    extendTableProps: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      tableHeader: [],
      valueList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      query: {},
      flag: null,
    }
  },
  watch: {
    extendTableProps: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.attributeData && val.attributeId && val.data) {
          _.assign(this.query, val)
          this.getTableList()
        }
      },
    },
  },
  created() {},
  methods: {
    async getTableList() {
      const params = {
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        ...this.query,
      }
      const res = await documentManagementService.getExtendData(params)
      if (res && res.code === 0) {
        this.flag = res.data.flag
        if (res.data.flag === 0) {
          this.tableHeader = [
            { name: '属性代码', val: 'code' },
            { name: '属性名称', val: 'name' },
            { name: '属性值', val: 'value' },
          ]
          this.valueList = res.data.attributeDataModels
          if (res.data.data.data?.length > 0) {
            this.reverseData(res.data.data.data[0], this.valueList)
          }
        } else {
          this.tableHeader = res.data.attributeDataModels
          this.valueList = res.data.data.data
          this.page.total = res.data.data.totalCount
        }
      }
    },
    // 详情解析数据
    reverseData(val, tableList) {
      if (!val) return
      Object.keys(val).forEach((item) => {
        tableList.forEach((el) => {
          if (`${el.tableName}.${el.columnName}` === item) {
            el.value = val[item]
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.can-not-input {
  ::v-deep input {
    pointer-events: none;
  }
}
.append_unit {
  position: relative;
  &::after {
    content: attr(data-unit);
    position: absolute;
    top: 1px;
    right: 0;
    padding: 0 20px;
    color: #515a6e;
    background: #ebeef5;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    height: 36px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.el-input-number.is-without-controls .el-input__inner {
  text-align: left !important;
}

</style>
